import React from 'react';
import { NumericTextField, NumericTextFieldData } from './NumericTextField';
import styles from '../../styles/components/answers/OpenEndedNumericData.module.css';
import { BaseNumericValidation } from '../../helpers/validationBuilder';

export interface OpenEndedNumericData {
  value: number | null;
  validation: BaseNumericValidation;
  onCompletion?: (v: number | null) => void;
  key?: string;
}

export const OpenEndedNumeric: React.FC<OpenEndedNumericData> = data => {
  const [error, setError] = React.useState<string | null>(null);
  const props: NumericTextFieldData = {
    ...data,
    error: error,
    onCompletion: (v: number | null, e: string | null) => {
      setError(e);
      if (data.onCompletion) {
        data.onCompletion(v);
      }
    },
  };
  return (
    <div className={styles.openEndNumericContainer}>
      <NumericTextField {...props} />
      {error && (
        <div className={styles.error}>
          <label>{error}</label>
        </div>
      )}
    </div>
  );
};
